import React from 'react';
import { useProgramImpliedSessions } from '../../useProgramImpliedSessions';
import EventTime from '../../../../../elements/EventTime';

// TODO: replace hardcoded string "Includes" with i18n

/**
 * A component that renders a list of implied sessions for a program item.
 *
 * If the component has no implied sessions, it renders nothing.
 *
 * @param {Object} props Component props
 * @param {Object} props.event Event object
 * @param {Object} props.session Program item object
 * @return {ReactElement} JSX element
 */
function ScheduleItemImpliedSessions(props) {
    const { event, session } = props,
        implied = useProgramImpliedSessions(event.id, session.id);

    if (!implied.length) return null;

    return (
        <>
            <div className="content">
                <h2
                    style={{
                        color: event.settings.primary_color,
                        marginBottom: 0,
                        textTransform: 'none',
                    }}>
                    Includes
                </h2>
            </div>
            <ul className="list">
                {implied.map((item, index) => (
                    <li
                        key={index}
                        style={{
                            backgroundColor: event.settings.primary_color,
                            color: 'white',
                        }}>
                        <div className="content">
                            <strong style={{ marginRight: '3ex' }}>
                                <EventTime event={event} time={item.start_local} />
                            </strong>
                            {item.name}
                        </div>
                    </li>
                ))}
            </ul>
        </>
    );
}

export default ScheduleItemImpliedSessions;
